import Vue from 'vue'
import 'vant/lib/index.css'
import App from './App.vue'
import router from './router'
import Wechat from 'vue-wechat'

import {
  Collapse,
  CollapseItem,
  RadioGroup,
  Radio,
  NavBar,
  Button,
  Dialog,
  Col,
  Row,
  Icon
} from 'vant'

Vue.config.productionTip = false
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(NavBar)
Vue.use(Button)
Vue.use(Dialog)
Vue.use(Col)
Vue.use(Row)
Vue.use(Icon)
Vue.use(Wechat)
import VueMomentLib from 'vue-moment-lib'
Vue.use(VueMomentLib)
import ba from 'vue-ba'
Vue.config.productionTip = false
Vue.use(ba, 'e435ac3da0068d8a2a6451fffcbccd57')
Vue.use(ba, {
  siteId: 'e435ac3da0068d8a2a6451fffcbccd57'
})
new Vue({
  el: '#app',
  router,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js